import React from 'react';
import { Popover, Space, Typography, Divider } from '@drip/drip-design';
import { expLogJSON } from '@/common/utils/log-utils/report';

const { Title, Paragraph } = Typography;

export default function ToolTipWithTag({ tagInfoArr, children }: any = {}) {
  // Popover的子元素必须要是原生标签，能接受onClick事件，不能用<>
  return (
    <Popover
      style={{ marginLeft: 10 }}
      placement="right"
      overlayStyle={{ width: 360 }}
      arrowPointAtCenter={true}
      content={tagInfoArr.length > 0 && <TagDescription tagInfoArr={tagInfoArr} />}
      overlayClassName="all-about-me-tag-toolTips-info"
    >
      {children}
    </Popover>
  );
}

function TagDescription({ tagInfoArr }: any) {
  //@ts-ignore
  expLogJSON('yx_shop', 'label_hover_expose');
  return tagInfoArr.map((item: any, key: number) => (
    <Typography key={key} className="tag-toolTips-info-item">
      <Title level={5} style={{ marginBottom: 10 }}>
        {item.name}
      </Title>
      <Paragraph style={{ fontSize: '12px', lineHeight: '22px' }}>{item.text}</Paragraph>
      {item.img &&
        (item.img.length > 1 ? (
          item.img.map((ele: any, index: number) => (
            <div key={ele}>
              <Paragraph style={{ marginTop: 16, marginBottom: 10, fontWeight: 'bold' }}>
                {index == 0 && '会场资源示意：'}
                {index == 2 && '首页资源示意：'}
                {index == 4 && '搜推资源示意：'}
                {index == 6 && '商品详情页示意：'}
              </Paragraph>
              <img key={ele} style={{ width: '100%', display: 'block' }} src={ele} />
            </div>
          ))
        ) : (
          <>
            <Paragraph style={{ marginBottom: 10, fontWeight: 'bold' }}>活动展示示意：</Paragraph>
            <img style={{ width: '100%', display: 'block' }} src={item.img[0]} />
          </>
        ))}
    </Typography>
  ));
}

export function RenderTagNames({
  tagNames,
  rightIcon,
}: {
  tagNames: { marketSceneTags?: Array<string>; activityTypeTags?: Array<string> };
  rightIcon: null | React.ReactDOM;
}) {
  const { marketSceneTags = [], activityTypeTags = [] } = tagNames;
  if (!marketSceneTags.length && !activityTypeTags.length) {
    return (
      <span className="tag-first-item-block">
        <span className="tag-first-item">营销活动</span>
        {rightIcon}
      </span>
    );
  }
  return (
    <span>
      {marketSceneTags.length > 0 ? (
        <span className="tag-first-item-block">
          {marketSceneTags.map((ele) => (
            <span className="tag-first-item" key={ele}>
              {ele}
            </span>
          ))}
          {activityTypeTags.length === 0 && rightIcon}
        </span>
      ) : null}

      {activityTypeTags.length > 0 ? (
        <span className="tag-sub-items-block">
          <Space size={6} className="tag-sub-items" split={<Divider type="vertical" style={{ margin: 0 }} />}>
            <span className="tag-sub-item">{activityTypeTags[0]}</span>
            {activityTypeTags.length > 1 && <span className="tag-sub-item">...+{activityTypeTags.length - 1}</span>}
          </Space>
          {rightIcon}
        </span>
      ) : null}
    </span>
  );
}

export function renderActivityTypeTags(tags: any) {
  return (
    <Space wrap={true}>
      {tags.map((ele: string) => (
        <span key={ele} className="activity-type-tags">
          {ele}
        </span>
      ))}
    </Space>
  );
}
